var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.theme.line_layout == 'Compact')?_c('NewLayout'):_c('Layout')
}
var staticRenderFns = []

export { render, staticRenderFns }